import { TemplateResult } from "lit-html"
import { SYSShellbarMenuIds } from "./parts/shellbar"
import { DirectiveResult } from "lit-html/directive.js"

export type HookSYSShellbarDisplayHint_Type = {
  mode: "left" | "right"
}
export type HookSYSShellbarDisplayHint_ReturnType = {
  res: TemplateResult | TemplateResult[] | DirectiveResult
}

export const HookSYSShellbarDisplayHint = "HookSYSShellbarDisplayHint"

export type HookSYSShellbarCustomBackButton_ReturnType = {
  res: TemplateResult | TemplateResult[] | DirectiveResult
}

export const HookSYSShellbarCustomBackButton = "HookSYSShellbarCustomBackButton"

export type SYSShellbarLanguagesGetType = {
  lang: string
  pic: any
}

export type SYSShellbarMenuGetType = {
  icon?: string
  description: string
  type?: "entry" | "separator"
  handler?: any
}

export type HookSYSShellbarLanguages_Type = {
  availableLanguages: string[]
  result: { items: SYSShellbarLanguagesGetType[] }
}

export const HookSYSShellbarLanguages = "HookSYSShellbarLanguages"

export type HookSYSShellbarMenu_Type = {
  menuId: SYSShellbarMenuIds
  result: { items: SYSShellbarMenuGetType[]; resultIcon: string }
}
export const HookSYSShellbarMenu = "HookSYSShellbarMenu"

export const HookSYSShellbarTitle = "HookSYSShellbarTitle"

export const HookSYSShellbarLogo = "HookSYSShellbarLogo"
